import { API_BASE_URL } from '../config/api';

export interface StoreItem {
  id: number;
  title: string;
  description?: string | null;
  image_url: string;
  link_url: string;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface StoreItemListResponse {
  items: StoreItem[];
  total: number;
}

export interface StoreItemPayload {
  title: string;
  description?: string;
  image_url: string;
  link_url: string;
  sort_order?: number;
  is_active?: boolean;
}

const BASE = `${API_BASE_URL}/store`;

export const storeApi = {
  listPublicItems: async (): Promise<StoreItemListResponse> => {
    const res = await fetch(`${BASE}/items`);
    if (!res.ok) {
      throw new Error('Không tải được sản phẩm cửa hàng');
    }
    return res.json();
  },

  listAllItems: async (token: string): Promise<StoreItemListResponse> => {
    const res = await fetch(`${BASE}/items/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      throw new Error('Không tải được danh sách sản phẩm');
    }
    return res.json();
  },

  uploadImage: async (token: string, file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(`${BASE}/items/upload-image`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || 'Upload ảnh thất bại');
    }
    const data = (await res.json()) as { url?: string; image_url?: string };
    return data.image_url || data.url || '';
  },

  createItem: async (token: string, payload: StoreItemPayload): Promise<StoreItem> => {
    const res = await fetch(`${BASE}/items`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || 'Tạo sản phẩm thất bại');
    }
    return res.json();
  },

  updateItem: async (
    token: string,
    id: number,
    payload: Partial<StoreItemPayload>,
  ): Promise<StoreItem> => {
    const res = await fetch(`${BASE}/items/${id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || 'Cập nhật sản phẩm thất bại');
    }
    return res.json();
  },

  deleteItem: async (token: string, id: number): Promise<void> => {
    const res = await fetch(`${BASE}/items/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || 'Xóa sản phẩm thất bại');
    }
  },
};
